export default __webpack_public_path__ + "assets/primaryLinkedin.623b9a9a.svg";